import * as R from 'ramda'
import { createSelector } from 'reselect'

import { getSettingEntity } from '../app/selectors'

const getCorporateDetailCorporateNo = state =>
  R.path(['corporateState', 'result', 'corporate'], state)

const getCorporates = state =>
  R.path(['corporateState', 'entities', 'corporates'], state)

export const getCorporateDetail = createSelector(
  getCorporateDetailCorporateNo,
  getCorporates,
  (corporateNo, corporates) => {
    if (R.isNil(corporateNo) || R.isNil(corporates)) {
      return null
    }
    return corporates[corporateNo]
  }
)

export const getCorporateCategoryNos = createSelector(
  getSettingEntity,
  frontendSetting =>
    R.pluck('corporateCategoryNo')(
      R.prop('corporateCategoryList', frontendSetting)
    )
)

export const getCorporateCategoryDisplayType = corporateCategoryNo =>
  createSelector(getSettingEntity, frontendSetting =>
    R.pipe(
      R.find(R.propEq('corporateCategoryNo', corporateCategoryNo)),
      R.prop('displayType')
    )(R.prop('corporateCategoryList', frontendSetting))
  )

const getCorporateCategories = state =>
  R.path(['corporateState', 'entities', 'corporateCategory'], state)

export const getCorporateCategory = corporateCategoryNo =>
  createSelector(getCorporateCategories, corporateCategories => {
    if (R.isNil(corporateCategories) || R.isNil(corporateCategoryNo)) {
      return null
    }
    return corporateCategories[corporateCategoryNo]
  })

export const getCorporateCategoryCorporate = corporateNo =>
  createSelector(getCorporates, corporates => {
    if (R.isNil(corporates) || R.isNil(corporateNo)) {
      return null
    }
    return corporates[corporateNo]
  })

export const getCorporateCategoryNames = createSelector(
  getCorporateCategoryNos,
  getCorporateCategories,
  (corporateCategoryNos, corporateCategories) => {
    if (R.isNil(corporateCategoryNos) || R.isNil(corporateCategories)) {
      return null
    }
    return R.map(
      corporateCategoryNo =>
        R.path([corporateCategoryNo, 'name'], corporateCategories),
      corporateCategoryNos
    )
  }
)

export const getCorporateHomeArticleIds = R.path(['articleState', 'result'])

const getCorporateHomeCorporateCategoryNo = R.path([
  'corporateState',
  'result',
  'corporateCategoryList',
  0
])

export const getCorporateHomeCorporateCategory = createSelector(
  getCorporateHomeCorporateCategoryNo,
  getCorporateCategories,
  getCorporates,
  (corporateHomeCorporateCategoryNo, corporateCategories, corporates) => {
    if (
      R.any(R.isNil)([
        corporateHomeCorporateCategoryNo,
        corporateCategories,
        corporates
      ])
    ) {
      return null
    }
    const corpCat = R.prop(
      corporateHomeCorporateCategoryNo,
      corporateCategories
    )
    return {
      ...corpCat,
      corporates: R.map(
        R.prop(R.__, corporates),
        R.path(['corporateList'], corpCat)
      )
    }
  }
)

const getCorporateHomeCorporateNos = R.path([
  'corporateState',
  'result',
  'corporateList'
])

export const getCorporateHomeCorporates = createSelector(
  getCorporateHomeCorporateNos,
  getCorporates,
  (corporateHomeCorporateNos, corporates) => {
    if (R.any(R.isNil)([corporateHomeCorporateNos, corporates])) {
      return null
    }
    return R.map(R.prop(R.__, corporates), corporateHomeCorporateNos)
  }
)
